<div class="hidden md:block shadow-sm bg-primary">
  @if (showBpostBusyMessage()) {
    <div class="bg-yellow-50 border-b border-yellow-200">
      <div class="max-w-[1220px] mx-auto py-3 px-4 sm:px-6 lg:px-0">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <fa-icon [icon]="exclamationTriangle" class="text-yellow-400"></fa-icon>
            <span class="ml-3 text-sm font-medium text-yellow-800">
              Bpost is momenteel druk bezet. Leveringen kunnen vertraging oplopen.
            </span>
          </div>
          <button (click)="removeMessage()" class="text-yellow-400 hover:text-yellow-500">
            <fa-icon [icon]="times"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  }

  <div class="max-w-[1220px] mx-auto px-4 sm:px-6 xl:px-0">
    <div class="flex items-center justify-between">
      <div class="flex items-center w-44">
        <app-logo></app-logo>
      </div>

      <div class="flex-1 mx-8 lg:w-[125rem]">
        <!--        <app-search-bar></app-search-bar>-->
      </div>

      <!--      <div class="flex items-center space-x-4 w-44 cursor-pointer group gap-2">-->
      <!--        <div class="hover text-primaryBackground cart-icon text-xs xl:text-md">-->
      <!--          <fa-icon [icon]="faShoppingCart" [ngClass]="{ flashit: flashShoppingCartIconBool }" size="lg"></fa-icon>-->
      <!--          @if (countNumberProductsInCart() !== 0) {-->
      <!--            <div-->
      <!--              class="absolute rounded-full w-5 text-center ml-3 text-sm bg-accent top-2"-->
      <!--              [ngClass]="{ flashit: flashShoppingCartIconBool }"-->
      <!--            >-->
      <!--              {{ countNumberProductsInCart() }}-->
      <!--            </div>-->
      <!--          }-->

      <!--          @defer (on viewport) {-->
      <!--            <app-cart class="hover-target relative"></app-cart>-->
      <!--          } @placeholder {-->
      <!--            <div></div>-->
      <!--          }-->
      <!--        </div>-->

      <!--        @if (isLoggedIn()) {-->
      <!--          <div class="relative text-link-on-primary-background account xl:mr-5 hover">-->
      <!--            <fa-icon class="mr-1" [icon]="faUserAlt" size="lg"></fa-icon>-->
      <!--            <div class="ellipsis username">{{ userEmail() }}</div>-->
      <!--            <app-account class="relative hover-target"></app-account>-->
      <!--          </div>-->
      <!--        } @else {-->
      <!--          <div-->
      <!--            id="header-login-btn"-->
      <!--            class="flex text-xs xl:text-md text-link-on-primary-background xl:mr-5"-->
      <!--            (click)="registerOrLogin()"-->
      <!--          >-->
      <!--            <fa-icon class="mr-1" [icon]="faUserAlt" size="lg"></fa-icon>-->
      <!--            <span class="hidden lg:block" style="margin-left: 2px">Aanmelden</span>-->
      <!--          </div>-->
      <!--        }-->
      <!--      </div>-->
    </div>
  </div>
</div>

<!--@if (platformService.isMobile()) {-->
<!--  <app-mobile-header-->
<!--    class="md:hidden"-->
<!--    [countNumberProductsInCart]="countNumberProductsInCart()"-->
<!--    [flashShoppingCartIconBool]="flashShoppingCartIconBool()"-->
<!--    (menuButtonClicked)="showMobileMenu.set(true)"-->
<!--    (cartButtonClicked)="showCartMenu.set(true)"-->
<!--  />-->

<!--  <app-mobile-menu class="md:hidden" [(showMenu)]="showMobileMenu" [(showCart)]="showCartMenu"></app-mobile-menu>-->
<!--}-->
